import PropTypes from 'prop-types'

import {Circle as RatingFeatureCircle} from './ratingFeatureCircle.js'
import {Line as RatingFeatureLine} from './ratingFeatureLine.js'
import {SIZES, TYPES} from './settings.js'

export default function RatingFeature({type = TYPES.LINE, ...props}) {
  const isTypeCircle = type === TYPES.CIRCLE
  const isTypeLine = type === TYPES.LINE

  return (
    <div className="mt-RatingFeature" data-testid={`type-${type}`}>
      {isTypeLine && <RatingFeatureLine {...props} />}
      {isTypeCircle && <RatingFeatureCircle {...props} />}
    </div>
  )
}

RatingFeature.displayName = 'RatingFeature'
RatingFeature.propTypes = {
  /** label */
  label: PropTypes.string,
  /** The maxScore of the rating */
  maxScore: PropTypes.number,
  /** rating value */
  rating: PropTypes.number.isRequired,
  /** If false, indicator will not be displayed */
  showIndicator: PropTypes.bool,
  /** The size of the progress bar  */
  size: PropTypes.string,
  /** progress bar type */
  type: PropTypes.oneOf(Object.values(TYPES))
}

export {TYPES as ratingFeatureTypes}
export {SIZES as ratingFeatureSizes}
